<template>
  <el-dialog
    title="Create affiliate"
    :visible="dialog"
    width="500px"
    top="3vh"
    :modal="true"
    :append-to-body="true"
    @close="setDialog(false); query = '';"
    destroy-on-close
  >
    <el-autocomplete
      v-model="query"
      :fetch-suggestions="search"
      :trigger-on-focus="false"
      :debounce="500"
      prefix-icon="el-icon-search"
      placeholder="Search user"
      @select="handleSelect"
      :maxlength="100"
      clearable
    >
      <div slot-scope="props" class="flex-start">
        {{ props.item.first_name }} {{ props.item.surname }}
      </div>
    </el-autocomplete>

    <h3 v-if="user">
      Click 'Save' to create affiliate code for user {{ user.first_name }}
      {{ user.surname }}
    </h3>

    <div slot="footer">
      <el-button
        type="primary"
        size="mini"
        :loading="loading"
        @click="createAffiliate(user.id)"
      >
        Save
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import axios from '@/plugins/axios'
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      query: '',
      user: null
    }
  },

  props: { activeTab: { type: String, required: true }},

  computed: {
    ...mapState('affiliate', ['loading', 'dialog', 'affiliateArtists']),
    ...mapState('user', ['users'])
  },

  methods: {
    ...mapActions('affiliate', ['createAffiliate', 'getAffiliatePartners']),
    ...mapMutations('affiliate', ['setUserId', 'setDialog']),

    search(query, callback) {
      if (query !== '' && query.length > 0) {
        axios.admin
          .get(`affiliate/search/${this.activeTab}`, {
            params: {
              name: query
            }
          })
          .then(r => {
            callback(r.data.users)
          })
          .catch(error => {
            console.log(error)
            this.$message({
              message: 'Search error, please try again',
              type: 'error'
            })
          })
      } else callback([])
    },

    handleSelect(data) {
      this.user = data
    },
  }
}
</script>
